import script from "./WaylensBasic.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaylensBasic.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__